// Solutions.js (antigo Product.js)
import React, { useState, useCallback } from 'react';
import './Solutions.css';
import './HeroSection.css';
import './ImageCarousel.css';
import AnimateOnScroll from './AnimateOnScroll';
import HeroSection from './HeroSection';
import { pulmoscanData, pulmogameData, saasData, pulmoflowData, saasPulmoflowData } from './solutionsData';
// Imagens e textos agora vivem em solutionsData.js

// cards migrados para solutionsData

const Solutions = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const closeModal = useCallback(() => setSelectedImage(null), []);

  // Sem effects: reinit está encapsulado no ImageCarousel

  return (
    <section className="solutions" id="solutions">
      <AnimateOnScroll variant="fadeUp">
        <h2 className="solutions-title">Nossas Soluções</h2>
      </AnimateOnScroll>
      {/* Hero do PulmoScan */}
      <AnimateOnScroll variant="fadeUp" delay={100}>
      <HeroSection
        className="pulmoscan-hero"
        title={pulmoscanData.title}
        subtitle={pulmoscanData.subtitle}
        paragraphs={pulmoscanData.paragraphs}
        bullets={pulmoscanData.bullets}
        badges={pulmoscanData.badges}
        singleImage={pulmoscanData.singleImage}
        images={pulmoscanData.images}
        onImageClick={setSelectedImage}
      />
      </AnimateOnScroll>

      {/* Hero do PulmoGame */}
      <AnimateOnScroll variant="fadeUp" delay={150}>
      <HeroSection
        className="pulgomame-hero"
        title={pulmogameData.title}
        subtitle={pulmogameData.subtitle}
        paragraphs={pulmogameData.paragraphs}
        bullets={pulmogameData.bullets}
        badges={pulmogameData.badges}
        singleImage={pulmogameData.singleImage}
        images={pulmogameData.images}
        onImageClick={setSelectedImage}
      />
      </AnimateOnScroll>

      {/* Hero do Portal de Gerenciamento (SaaS) */}
      <AnimateOnScroll variant="fadeUp" delay={150}>
      <HeroSection
        className="saas-hero"
        title={saasData.title}
        subtitle={saasData.subtitle}
        paragraphs={saasData.paragraphs}
        bullets={saasData.bullets}
        badges={saasData.badges}
        singleImage={saasData.singleImage}
        images={saasData.images}
        onImageClick={setSelectedImage}
      />
      </AnimateOnScroll>

      {/* Hero do PulmoFlow */}
      <AnimateOnScroll variant="fadeUp" delay={150}>
      <HeroSection
        className="pulmoflow-hero"
        title={pulmoflowData.title}
        subtitle={pulmoflowData.subtitle}
        inDevelopment={pulmoflowData.inDevelopment}
        paragraphs={pulmoflowData.paragraphs}
        bullets={pulmoflowData.bullets}
        badges={pulmoflowData.badges}
        singleImage={pulmoflowData.singleImage}
        images={pulmoflowData.images}
        onImageClick={setSelectedImage}
      />
      </AnimateOnScroll>

      {/* Hero do Portal de Gerenciamento PulmoFlow */}
      <AnimateOnScroll variant="fadeUp" delay={150}>
      <HeroSection
        className="saas-pulmoflow-hero"
        title={saasPulmoflowData.title}
        subtitle={saasPulmoflowData.subtitle}
        inDevelopment={saasPulmoflowData.inDevelopment}
        paragraphs={saasPulmoflowData.paragraphs}
        bullets={saasPulmoflowData.bullets}
        badges={saasPulmoflowData.badges}
        singleImage={saasPulmoflowData.singleImage}
        images={saasPulmoflowData.images}
        onImageClick={setSelectedImage}
      />
      </AnimateOnScroll>
    
      <AnimateOnScroll variant="fadeUp" delay={100}>
      <div className="features">
        <h3>Recursos por Ecossistema</h3>

        <div className="feature-groups">
          <div className="feature-group">
            <div className="feature-group-header">
              <h4 className="feature-group-title">Ecossistema PulmoScan (BTOne)</h4>
              <p className="feature-group-subtitle">
                Profissional: avaliações, gestão e relatórios. Inclui o módulo de jogos <strong>PulmoGame</strong>.
              </p>
            </div>

            <div className="feature-grid feature-grid--compact">
              <div className="feature-item">
                <span className="feature-icon">📱</span>
                <h4>PulmoScan</h4>
                <p>Cadastro, avaliação e acompanhamento do paciente</p>
              </div>
              <div className="feature-item">
                <span className="feature-icon">🎮</span>
                <h4>PulmoGame</h4>
                <p>Treinos gamificados integrados para engajamento</p>
              </div>
              <div className="feature-item">
                <span className="feature-icon">🖥️</span>
                <h4>Portal SaaS</h4>
                <p>Administração web para clínicas e profissionais</p>
              </div>
              <div className="feature-item">
                <span className="feature-icon">📊</span>
                <h4>Avaliações & Relatórios</h4>
                <p>PImáx/PEmáx, normalização e exportação em PDF</p>
              </div>
            </div>
          </div>

          <div className="feature-group">
            <div className="feature-group-header">
              <h4 className="feature-group-title">Ecossistema PulmoFlow (BTTwo)</h4>
              <p className="feature-group-subtitle">
                Paciente: coleta de pico de fluxo em casa com gamificação e envio ao profissional (telemonitoramento).
              </p>
            </div>

            <div className="feature-grid feature-grid--compact">
              <div className="feature-item">
                <span className="feature-icon">🌬️</span>
                <h4>PulmoFlow</h4>
                <p>Coleta de PEF com gamificação e histórico</p>
              </div>
              <div className="feature-item">
                <span className="feature-icon">📝</span>
                <h4>ACT & CAT</h4>
                <p>Questionários integrados para acompanhamento</p>
              </div>
              <div className="feature-item">
                <span className="feature-icon">🖥️</span>
                <h4>Portal SaaS</h4>
                <p>Profissional analisa amostras e questionários enviados</p>
              </div>
              <div className="feature-item">
                <span className="feature-icon">🏠</span>
                <h4>Telemonitoramento</h4>
                <p>Paciente coleta em casa e o profissional acompanha à distância</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      </AnimateOnScroll>
      {/* Modal de imagem ampliada */}
      {selectedImage && (
        <div className="image-modal" onClick={closeModal}>
          <img src={selectedImage} alt="Visualização ampliada" />
        </div>
      )}
    </section>
  );
};

export default Solutions;
